import {Injectable} from '@angular/core';
import {GestionTercerosService} from '../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import {DataSaveService} from './data-save.service';
import {
    DataVehiculosService
} from '../../dms/modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';

@Injectable()
export class ShortcutService {

    showTercerosModal: boolean = false;
    showVehiculosModal: boolean = false;
    private readonly tercerosVista = 'gestionTerceros';
    private readonly vehicleTransmitter = 'gestionVehiculos';

    constructor(
        private _gestionTercerosService: GestionTercerosService,
        private _dataSaveService: DataSaveService,
        private _dataVehiculosService: DataVehiculosService
    ) {
    }

    navigateGestionTerceros(customerCode) {
        this._gestionTercerosService.openNewCustomer(this.tercerosVista, false);
        this._gestionTercerosService.setCustomer(customerCode);
        this.showTercerosModal = true;
    }

    navigateGestionVehiculos(vehicleChassis, editable = false) {
        this._dataSaveService.setFormulario(this.vehicleTransmitter, { 'form': null });
        this._dataVehiculosService.newCustomer = false;
        const auxNew = { 'isNew': false };
        this._dataSaveService.setCustomerNew(this.vehicleTransmitter, auxNew);
        const auxChassis = { 'chassis': vehicleChassis };
        this._dataSaveService.setChassis(this.vehicleTransmitter, auxChassis);
        this._dataSaveService.setDatosRowTabla(this.vehicleTransmitter, {CustomerCode: null, Chassis: vehicleChassis})

        const currentStep = 2;
        const auxSteep = {
            'step': currentStep
        };
        this._dataSaveService.setStepsView('gestionVehiculos', auxSteep);
        if(editable === true){
            this._dataSaveService.setCanEditVehicle(true);
        }
        this.showVehiculosModal = true;
    }

    closeTercerosVehiculosModal() {
        if (this.showTercerosModal) {
            this._gestionTercerosService.reset(this.tercerosVista)
            this.showTercerosModal = false;
        }
        if (this.showVehiculosModal) {
            this._dataSaveService.clearAll();
            this._dataSaveService.setCanEditVehicle(false);
            this.showVehiculosModal = false;
        }
    }
}
